import { get, patch } from "../../api/api";
import { IRespostaFuncao } from 'src/integracoes/modelos/funcoes';

// Listar parametros integracao
export const obtemParametrosIntegracao = async (id: string) => {
  return await get<IRespostaFuncao<any>>(`/empresas/${id}/obtem-parametros-integracao`);
};

// Atualizar parametros integracao
export const atualizarParametrosIntegracao = async (
  id: string,
  payload: any
): Promise<IRespostaFuncao<any>> => {
  return await patch<IRespostaFuncao<any>>(
    `/empresas/${id}/atualiza-parametros-integracao`,
    payload
  );
};

// Validar dados importados pelo pgloader
export const validarDadosPgloader = async (
  id: string
): Promise<IRespostaFuncao<any>> => {
  return await get<IRespostaFuncao<any>>(
    `/empresas/${id}/validar-dados-pgloader`
  );
};
